import { notNil } from '@sixfold/typed-primitives';
import React, { memo } from 'react';

import { useTimeZone } from './timezone_context';
import { formatTimestamp } from './utils';

interface FormattedDateProps {
  date: string | Date | null | undefined;
  propsTimezone?: string;
  showDate?: boolean;
  showTime?: boolean;
  showTimezone?: boolean;
  additionalMessage?: string;
  showSecondsAndMillis?: boolean;
}

export const FormattedDate: React.FunctionComponent<FormattedDateProps> = memo(
  function FormattedDate({
    date,
    propsTimezone,
    showDate = true,
    showTime = true,
    showTimezone = true,
    additionalMessage = '',
    showSecondsAndMillis = false,
  }) {
    const { timeZone } = useTimeZone();

    const timezoneToUse = notNil(propsTimezone) ? propsTimezone : timeZone;

    const formatted = formatTimestamp(date, {
      timeZone: timezoneToUse,
      showDate,
      showTime,
      showTimezone,
      showSecondsAndMillis,
    });

    if (!formatted) {
      return <>{' - '}</>;
    }

    return <>{`${formatted}${additionalMessage}`}</>;
  },
  (previous, next) =>
    previous.showDate === next.showDate &&
    previous.showTime === next.showTime &&
    previous.showSecondsAndMillis === next.showSecondsAndMillis &&
    previous.propsTimezone === next.propsTimezone &&
    previous.showTimezone === next.showTimezone &&
    previous.additionalMessage === next.additionalMessage &&
    notNil(previous.date) &&
    notNil(next.date) &&
    previous.date?.valueOf() === next.date?.valueOf(),
);
